import { useTreatmentBase } from "./useTreatmentBase";

export const createTreatmentHook = (payType, listOptionsSelector, getDataSelector) => ({ interventionId, formularyId }) =>
  useTreatmentBase({ interventionId, formularyId, payType, listOptionsSelector, getDataSelector });
